import React, { useEffect } from 'react';
import Message from './message';
import { useSnackbar } from 'notistack';

const GlobalMessage = () => {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    Message.open = (message, options?) => {
      enqueueSnackbar(
        <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{message}</div>,
        options,
      );
    };
  }, []);
  return null;
};
export default GlobalMessage;
